import { selectCountries } from "../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { provinces } from "../../../../shared";
import {
  selectCountry,
  selectIsDefaultCountrySelected,
  selectIsNotDefaultCountrySelected,
} from "../../../../store/HOC/genericUI.selectors";
import { postalCodeMask } from "../../../../utilities/masks";
import {
  shouldDisplayCompanyPerpetrator,
  shouldDisplayCompanyOwner,
  selectPerpetratorCompanyData,
  selectUIData,
  selectPerpetratorAvailableCities,
} from "../perpetrator.selectors";
import {
  setAvailableCities,
  setUIField,
  setUIObjectField,
} from "../perpetrator.slice";

import { ComponentId } from "./enums";

export const form = (
  title: string,
  selector:
    | typeof shouldDisplayCompanyPerpetrator
    | typeof shouldDisplayCompanyOwner
): FormSchema<SimpleFormSchemaComponents> => ({
  id: [FormId.PERPETRATOR_COMPANY_DATA, title].join("-"),
  formId: FormId.PERPETRATOR_COMPANY_DATA,
  selector: selectPerpetratorCompanyData,
  isVisible: selector,
  content: [
    {
      sections: [
        {
          title: title,
          id: "perpetrator-owner-company-details-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_COMPANY_NAME,
              label: "Nazwa firmy",
              placeholder: "Podaj pełną nazwę firmy",
            },
          ],
        },
        {
          id: "perpetrator-owner-company-details-2",
          wrapper: { xs: 6 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_COMPANY_REGON,
              label: "REGON",
            },
          ],
        },
        {
          id: "perpetrator-owner-company-details-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("companyDataphone"),
              id: ComponentId.PERPETRATOR_COMPANY_PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_COMPANY_EMAIL,
              label: "Email",
            },
          ],
        },
        {
          title: "Adres",
          id: "perpetrator-owner-company-details-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_COMPANY_STREET,
              label: "Ulica",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_COMPANY_STREET_2,
              label: "Numer budynku / mieszkania",
            },
          ],
        },
        {
          id: "perpetrator-owner-company-details-5",
          wrapper: { xs: 12 },
          components: [
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "companyData[country]"
              ),
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.PERPETRATOR_COMPANY_ZIP_CODE_PL,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "companyData[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_COMPANY_ZIP_CODE_GENERIC,
              label: "Kod pocztowy",
            },
            // LPPLWEBMOB-728
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.SELECT_CITY,
              id: ComponentId.PERPETRATOR_COMPANY_CITY,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectPerpetratorAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_COMPANY_CITY,
              label: "Miejscowość",
            },
          ],
        },
        {
          id: "perpetrator-owner-company-details-6",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.PERPETRATOR_COMPANY_COUNTRY,
              items: selectCountries,
              onChange: setUIField,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.PERPETRATOR_COMPANY_PROVINCE,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                "companyData[country]"
              ),
              label: "Województwo",
              items: [...provinces],
            },
          ],
        },
      ],
    },
  ],
});

export const insurance: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.PERPETRATOR_COMPANY_DATA,
  id: [FormId.PERPETRATOR_COMPANY_DATA, "insurance"].join("-"),
  selector: selectPerpetratorCompanyData,
  isVisible: shouldDisplayCompanyOwner,
  content: [
    {
      sections: [
        {
          title: "Dane polisy",
          id: "perpetrator-car-insurance",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_COMPANY_OC_NUMBER,
              label: "Numer polisy OC",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.PERPETRATOR_COMPANY_INSURANCE_COMPANY,
              label: "Towarzystwo ubezpieczeniowe",
            },
          ],
        },
      ],
    },
  ],
};
